import { IElektroSamsvarserklaringFELRapport } from "../reportSchemas/elektroSamsvarserklaringFELSchema.js";

export const ELEKTRO_SAMSVARSERKLARING_FEL_INIT_DATA: IElektroSamsvarserklaringFELRapport = {
  generellInfo: {
    utarbeidetAv: "",
    kontrollertAv: "",
    godkjentAv: "",
    dokumentNr: "",
    revisjonsNr: "",
  },
  oppdragsInfo: {
    oppdragsNavn: "Prosjekt test",
    oppdragsNummer: "1001080",
    oppdragsGiver: {
      navn: "",
      kontaktPerson: "",
      adresse: "",
      postNr: "",
      sted: "",
      telefon: "",
      email: "",
      kundenummerEllerProsjektnummer: "",
    },
    oppdragsLeder: "",
  },
  prosjekterende: {
    navn: "",
    kontaktPerson: "",
    adresse: "",
    postNr: "",
    sted: "",
    telefon: "",
    email: "",
    oppdragsNummer: "",
  },
  anleggEllerprosjekt: {
    anleggsnavnEllerProsjektnavn: "",
    adresse: "",
    postNr: "",
    sted: "",
    SSBnr: "",
    typeAnlegg: "",
  },
  fravikFraAnvendteNormer: "",
  anvendteNormerOgStandarder: [],
  andreTekniskeSpesifikasjoner: [
    {
      spesifikasjonsId: "6.1",
      spesifikasjonsType: "",
      argang: "",
    },
    {
      spesifikasjonsId: "6.2",
      spesifikasjonsType: "",
      argang: "",
    },
    {
      spesifikasjonsId: "6.3",
      spesifikasjonsType: "",
      argang: "",
    },
  ],
  beskrivelseAvOppdrag: "",
  underlagsdokumentasjon: {
    dokumentplan: "",
    fordelingsskjema: "",
    beskrivelser: "",
    resultatFraBrukermoeter: "",
    elektrotekniskeBeregninger: "",
    risikoburdering: "",
  },
  generatedAt: "",
  generatedBy: "",
};
